export default {
    DesignReport: 0,
    RenderReport: 1,
    ExportReport: 2
};